/* Bea Joyas — JS base del tema. Vanilla, respeta prefers-reduced-motion. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Header sólido al scrollear ---- */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 28);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Extras del header: mega menú al hover + bump del carrito (portado del <script> inline que tenía header.liquid) ---- */
  function initHeaderExtras() {
    var hdr = document.querySelector('.bea-hdr');
    if (!hdr) return;
    hdr.querySelectorAll('[data-mega-trigger]').forEach(function (t) {
      t.addEventListener('mouseenter', function () { hdr.classList.add('mega-open'); });
    });
    var cart = hdr.querySelector('.bea-hdr__cart');
    var countEl = hdr.querySelector('[data-cart-count]');
    if (cart && countEl) {
      var prev = parseInt(countEl.textContent, 10) || 0;
      var mo = new MutationObserver(function () {
        var now = parseInt(countEl.textContent, 10) || 0;
        if (now > prev) {
          cart.classList.add('is-bumped');
          setTimeout(function () { cart.classList.remove('is-bumped'); }, 450);
        }
        prev = now;
      });
      mo.observe(countEl, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ---- Drawers (menú mobile, buscador, favoritos, carrito) por data-attributes ---- */
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        var d = document.getElementById(opener.getAttribute('data-drawer-open'));
        if (d) {
          // cerrar cualquier otro drawer abierto para que no se pisen visualmente
          document.querySelectorAll('[data-drawer].is-open').forEach(function (o) { if (o !== d) o.classList.remove('is-open'); });
          d.classList.add('is-open'); document.body.style.overflow = 'hidden';
          var input = d.querySelector('[data-search-input]');
          if (input) setTimeout(function () { input.focus(); }, 150);
        }
      }
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) {
        var dc = closer.closest('[data-drawer]');
        if (dc) { dc.classList.remove('is-open'); document.body.style.overflow = ''; }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-drawer].is-open').forEach(function (d) { d.classList.remove('is-open'); });
        document.body.style.overflow = '';
      }
    });
  }

  /* ---- Favoritos (wishlist), vanilla — comparte localStorage "bj_wishlist" con la SPA React de la home ---- */
  function getWish() { try { return JSON.parse(localStorage.getItem('bj_wishlist') || '[]'); } catch (e) { return []; } }
  function setWish(ids) { try { localStorage.setItem('bj_wishlist', JSON.stringify(ids)); } catch (e) {} }

  function renderWishDrawer(ids) {
    var body = document.getElementById('WishDrawerBody');
    var footer = document.getElementById('WishDrawerFooter');
    var countEl = document.getElementById('WishDrawerCount');
    if (countEl) countEl.textContent = '(' + ids.length + ')';
    if (!body) return;
    var idx = window.BEA_WISH_INDEX || {};
    if (!ids.length) {
      body.innerHTML = '<div class="wishd__empty">' +
        (window.Icon && window.Icon.heart ? '' : '') +
        '<p>Todavía no guardaste nada</p><span>Tocá el corazón en cualquier pieza para guardarla acá.</span></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    var html = '';
    ids.forEach(function (id) {
      var p = idx[id];
      if (!p) return;
      html += '<div class="wishd__item">' +
        '<a href="' + p.url + '" class="wishd__ph">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="wishd__info">' +
          '<div class="wishd__row">' +
            '<a href="' + p.url + '" class="wishd__name">' + p.title + '</a>' +
            '<button type="button" class="wishd__remove" data-wish-remove="' + id + '" aria-label="Quitar">×</button>' +
          '</div>' +
          '<div class="wishd__price">' + p.price + '</div>' +
          '<a href="' + p.url + '" class="wishd__view">' + (p.available ? 'Ver pieza' : 'Sin stock') + '</a>' +
        '</div>' +
      '</div>';
    });
    body.innerHTML = html;
    if (footer) { footer.style.display = 'flex'; footer.innerHTML = '<button type="button" class="btn btn--ghost btn--sm" data-wish-clear>Vaciar</button><a href="' + (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'collections/all" class="btn btn--solid" style="flex:1;text-align:center">Seguir explorando</a>'; }
  }

  function syncWishUI() {
    var ids = getWish().map(String);
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-toggle');
      var active = ids.indexOf(id) > -1;
      btn.classList.toggle('is-saved-btn', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var wrap = btn.closest('.bj-card__wish');
      if (wrap) wrap.classList.toggle('is-saved', active);
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = ids.length;
      el.hidden = ids.length === 0;
    });
    renderWishDrawer(ids);
  }

  function toggleWish(id) {
    id = String(id);
    var ids = getWish().map(String);
    var i = ids.indexOf(id);
    if (i > -1) ids.splice(i, 1); else ids.unshift(id);
    setWish(ids);
    syncWishUI();
  }

  function initWishlist() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-wishlist-toggle]');
      if (toggle) { e.preventDefault(); e.stopPropagation(); toggleWish(toggle.getAttribute('data-wishlist-toggle')); return; }
      var remove = e.target.closest('[data-wish-remove]');
      if (remove) { e.preventDefault(); toggleWish(remove.getAttribute('data-wish-remove')); return; }
      if (e.target.closest('[data-wish-clear]')) { setWish([]); syncWishUI(); }
    });
    syncWishUI();
  }

  function init() { initReveal(); initStickyHeader(); initHeaderExtras(); initDrawers(); initWishlist(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
